// client/src/api/detallePedido.js
import api from "./config.js";

    // Obtener todos los detalles de pedido
    export const getDetallesPedido = async () => {
    const { data } = await api.get("/detalle-pedido");
    return Array.isArray(data) ? data : data.detalles || [];
    };

    // Obtener un detalle de pedido por ID
    export const getDetallePedido = async (id) => {
    const { data } = await api.get(`/detalle-pedido/${id}`);
    return data;
    };

    // Crear un nuevo detalle de pedido
    export const createDetallePedido = async (detalle) => {
    const { data } = await api.post("/detalle-pedido", detalle);
    return data;
    };

    // Actualizar detalle de pedido
    export const updateDetallePedido = async (id, detalle) => {
    const { data } = await api.put(`/detalle-pedido/${id}`, detalle);
    return data;
    };

    // Eliminar detalle de pedido
    export const deleteDetallePedido = async (id) => {
    const { data } = await api.delete(`/detalle-pedido/${id}`);
    return data;
    };

    // Obtener detalles de un pedido específico
    export const getDetallesByPedido = async (idPedido) => {
    const { data } = await api.get(`/detalle-pedido/pedido/${idPedido}`);
    return Array.isArray(data) ? data : data.detalles || [];
    };